<template>
    <RoundButton class="clear-button" background="var(--red)" height="48px">
        <span class="icon-container"><i class="icon-trash"></i></span>
        <span>
            {{ $t("general.delete") }}
        </span>
    </RoundButton>
</template>

<script lang="ts">
import RoundButton from "@/components/buttons/RoundButton.vue";
import colors from "@/styles/colors";

export default {
    name: "ClearRecordButton",
    components: {
        RoundButton
    },
    data() {
        return {
            colors
        };
    }
};
</script>
<style scoped>
.clear-button {
    color: var(--white);
}

.icon-container {
    margin-right: 5px;
}
</style>
